import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, fontSizing, spacing, TKey, usePublicaTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const days = [
  { label: 'Mon', tKey: 'Mon' as TKey, value: 'Monday' },
  { label: 'Tue', tKey: 'Tue' as TKey, value: 'Tuesday' },
  { label: 'Wed', tKey: 'Wed' as TKey, value: 'Wednesday' },
  { label: 'Thu', tKey: 'Thu' as TKey, value: 'Thursday' },
  { label: 'Fri', tKey: 'Fri' as TKey, value: 'Friday' },
  { label: 'Sat', tKey: 'Sat' as TKey, value: 'Saturday' },
  { label: 'Sun', tKey: 'Sun' as TKey, value: 'Sunday' },
];

const getBorderStyle = (idx: number, isLast?: boolean): CSS.Properties => {
  if (isLast) {
    return {
      borderRadius: '0 5px 5px 0',
      borderLeft: 'none',
    };
  }
  if (idx === 0) {
    return {
      borderRadius: '5px 0 0 5px',
    };
  } else {
    return {
      borderRadius: 'none',
      borderLeft: 'none',
    };
  }
};

interface IProps {
  selected: Set<string>;
  onClick: (value: string) => void;
}

export const DaypartingDayToggles = ({ selected, onClick }: IProps) => {
  const { t } = usePublicaTranslation();
  return (
    <Cols paddingBottom={spacing.extraSmall} wrap style={{ alignItems: 'center' }}>
      {days.map((day, i) => {
        const isSelected = selected.has(day.value);

        return (
          <Col key={day.label}>
            <button
              onClick={() => onClick(day.value)}
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '48px',
                borderWidth: 0,
                lineHeight: 'inherit',
                fontFamily: 'inherit',
                fontStyle: 'inherit',
                whiteSpace: 'nowrap',
                margin: 0,
                backgroundColor: isSelected ? publicaColors.lavender : 'inherit',
                color: isSelected ? publicaColors.veryDarkGray : publicaColors.darkGray,
                transition: 'background 0.2s ease-out',
                minWidth: '40px',
                fontSize: fontSizing.small,
                fontWeight: FONT_WEIGHT.bold,
                border: `1px solid ${publicaColors.lightGray}`,
                padding: '4px 0px',
                cursor: 'pointer',
                ...getBorderStyle(i, i === 6),
              }}
            >
              {t(day.tKey)}
            </button>
          </Col>
        );
      })}
    </Cols>
  );
};
